<template>
  <div class="zym-login">

    <img class="logo" src="../assets/bg-head.png">
    <div class="zym-title">手机助手</div>
    <div class="mobile">
      <div class="zym-field-icon">
        <img src="../assets/icon-login-user.png">
      </div>
      <div class="zym-cell">
        <input maxlength="11" placeholder="请输入手机号" value="" class="van-field-control">
      </div>
    </div>
    <div class="mobile">
      <div class="zym-field-icon">
        <img src="../assets/icon-login-suo.png">
      </div>
      <div class="zym-cell">
        <input type="password" maxlength="11" placeholder="请输入密码" value="" class="van-field-control">
      </div>
    </div>
    <div class="login-button">
      <span>登录</span>
      <span class="btn-green">微信一键登录</span>
    </div>
    <div class="desc">湖南惠农科技有限公司</div>

  </div>
</template>

<script>
import { encryption } from "@/api/login";
import { loginUser } from "@/api/bapi";
import { getinfo } from "@/api/bapi";
export default {
  name: "Login",

  data() {
    return {

    }
  },

  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.zym-login {
  position: relative;
  min-width: 100vw;
  min-height: 100vh;
  background-color: #fff;
}
.zym-login .logo {
  display: block;
  width: 100%;
  height: 120px;
  object-fit: cover;
  object-position: center;
}
.zym-login .zym-title {
  margin: 10px 10px 50px 10px;
  color: #39BF3E;
  font-size: 20px;
  text-align: center;
}
  .zym-login .mobile {
    display: flex;
    align-content: space-between;
    margin: 15px 50px 0 50px;
  }
.zym-login .mobile .zym-field-icon {
  position: relative;
  top: 10px;
  width: 14px;
  height: 14px;
}
.zym-login .mobile .zym-field-icon img {
    display: block;
  width: 100%;
  height: 100%;
  }
.zym-login .mobile .zym-cell {
  flex: 1;
    margin-left: 12px;
    line-height: 30px;
    border-bottom: 1px solid #ddd;
  }
.zym-login .mobile .zym-cell input {
  font-size: 14px;
  color: #333;
  outline:none;
}
  .zym-login .login-button {
    margin: 35px 37px 0 37px;
  }
.zym-login .login-button span {
  display: block;
  height: 40px;
  line-height: 40px;
  font-size: 17px;
  color: #39BF3E;
  text-align: center;
  border: 1px solid #909090;
  border-radius: 20px;
}
.zym-login .login-button span:nth-child(2) {
  margin-top: 10px;
}
.zym-login .login-button .btn-green {
    color: #fff;
    background-color: #39BF3E;
    border: 1px solid #39BF3E;
  }
  .zym-login .desc {
    position: absolute;
    bottom: 15px;
    left: 0;
    width: 100%;
    color: #909090;
    font-size: 12px;
    text-align: center;
  }

input::-webkit-input-placeholder {
  color: #ddd;
}
input:-moz-placeholder {
  color: #ddd;
}
input::-moz-placeholder {
  color: #ddd;
}
input:-ms-input-placeholder {
  color: #ddd;
}



</style>



// WEBPACK FOOTER //
// src/components/Login2.vue